export const AUCTIONS_CATALOG_ID = window.$('script[data-auctions-catalog-id]').data('auctions-catalog-id');
export const AUCTION_STARTED_STATE = 'started';
export const INTERNET_AUCTIONS_PAGE_PARAMS = {
  searchQuery: 'q',
  perPage: 'perPage',
  onlyActiveAuctions: 'onlyActiveAuctions',
  artworkParam: 'artwork_id',
};
export const INTERNET_AUCTIONS_STATES = {
  SOLD: 'sold',
  UNSOLD: 'unsold',
};



// WEBPACK FOOTER //
// ./app/javascript/packs/internet_auctions/consts.js